import {
    ADMIN_REQUEST_START,
    ADMIN_REQUEST_SUCCESS,
    ADMIN_REQUEST_FAILED,
    ADMIN_REQUEST_NO_PERMISSION,
    ADMIN_UPDATE_FIELD,
    ADMIN_OPEN_STORE_UPDATE_FORM,
    ADMIN_STORE_UPDATE,
    ADMIN_STORE_INSERT,
    ADMIN_STORE_DELETE,
    ADMIN_OPEN_MANAGER_UPDATE_FORM,
    ADMIN_MANAGER_UPDATE,
    ADMIN_MANAGER_INSERT,
    ADMIN_MANAGER_DELETE,
    ADMIN_OPEN_HNAME_UPDATE_FORM,
    ADMIN_HNAME_UPDATE,
    ADMIN_HNAME_INSERT,
    ADMIN_HNAME_DELETE,
    ADMIN_OPEN_SGROUP_UPDATE_FORM,
    ADMIN_SGROUP_UPDATE,
    ADMIN_SGROUP_INSERT,
    ADMIN_SGROUP_DELETE,
    ROUTES_OPEN_FORM
}
    from '../actions/AdminActions'



const initialState = {
    status:'Initialize'
};

export default function AdminReducer(state = initialState, action) {

    if (!action){
        return state;
    }

    switch (action.type) {
        case ADMIN_REQUEST_START:
            return {...state, status:'request',country:action.country,date:action.date,
                product:action.product,
                platform:action.platform};
        case ADMIN_REQUEST_SUCCESS:
            return {...state, status:'success',stores:action.stores,managers:action.managers,handleName:action.handleName,storeGroup:action.storeGroup};
        case ADMIN_REQUEST_NO_PERMISSION:
            return {...state, status:'no_permission'};
        case ADMIN_REQUEST_FAILED:
            return {...state, status:'error'};

        case ADMIN_UPDATE_FIELD:
            var update = {...state[action.storeOrManager]};
            update[action.field] = action.value;
            return {...state,errorUpdate:false, [action.storeOrManager]: update};

        case ADMIN_OPEN_STORE_UPDATE_FORM:
            return {...state,errorUpdate:false,storeInEdit:action.store};

        case ADMIN_STORE_UPDATE:

            var modifiedStores = [];
            for (let index in state.stores){

                if (state.stores[index].id === action.data[0].id){

                    modifiedStores.push(action.data[0]);
                }
                else{
                    modifiedStores.push(state.stores[index]);

                }
            }

            return {...state,stores:modifiedStores,errorUpdate:false};
        case ADMIN_STORE_INSERT:

            var modifiedStores = [];
            for (var index in state.stores){
                modifiedStores.push(state.stores[index] );
            }

            for (var index in action.data) {
                modifiedStores.push(action.data[index]);
            }

            return {...state,stores:modifiedStores,errorUpdate:false};

        case ADMIN_STORE_DELETE:

            var modifiedStores = [];
            for (var index in state.stores){

                if (state.stores[index].id !== action.id){

                    modifiedStores.push({...state.stores[index] });
                }
            }

            return {...state,stores:modifiedStores,errorUpdate:false};


        case ADMIN_OPEN_MANAGER_UPDATE_FORM:
            return {...state,errorUpdate:false,managerInEdit:action.manager};

        case ADMIN_MANAGER_UPDATE:

            var modifiedManagers = [];
            for (let index in state.managers){

                if (state.managers[index].id === action.data[0].id){

                    modifiedManagers.push(action.data[0]);
                }
                else{
                    modifiedManagers.push(state.managers[index]);

                }
            }

            return {...state,managers:modifiedManagers,errorUpdate:false};

        case ADMIN_MANAGER_INSERT:

            var modifiedManagers = [];
            for (var index in state.managers){
                modifiedManagers.push(state.managers[index] );
            }

            for (var index in action.data) {
                modifiedManagers.push(action.data[index]);
            }

            return {...state,managers:modifiedManagers,errorUpdate:false};

        case ADMIN_MANAGER_DELETE:

            var modifiedManagers = [];
            for (var index in state.managers){

                if (state.managers[index].id !== action.id){

                    modifiedManagers.push({...state.managers[index] });
                }
            }

            return {...state,managers:modifiedManagers,errorUpdate:false};

        case ADMIN_OPEN_HNAME_UPDATE_FORM:
            return {...state,errorUpdate:false,handleNameInEdit:action.hname};

        case ADMIN_HNAME_UPDATE:

            var modifiedManagers = [];
            for (let index in state.handleName){

                if (state.handleName[index].id === action.data[0].id){

                    modifiedManagers.push(action.data[0]);
                }
                else{
                    modifiedManagers.push(state.handleName[index]);

                }
            }

            return {...state,handleName:modifiedManagers,errorUpdate:false};

        case ADMIN_HNAME_INSERT:

            var modifiedManagers = [];
            for (var index in state.handleName){
                modifiedManagers.push(state.handleName[index] );
            }

            for (var index in action.data) {
                modifiedManagers.push(action.data[index]);
            }

            return {...state,handleName:modifiedManagers,errorUpdate:false};

        case ADMIN_HNAME_DELETE:

            var modifiedCustomers = [];
            for (var index in state.handleName){

                if (state.handleName[index].id !== action.id){

                    modifiedCustomers.push({...state.handleName[index] });
                }
            }

            return {...state,handleName:modifiedCustomers,errorUpdate:false};


        case ADMIN_OPEN_SGROUP_UPDATE_FORM:
            return {...state,errorUpdate:false,storeGroupInEdit:action.sgroup};

        case ADMIN_SGROUP_UPDATE:

            var modifiedManagers = [];
            for (let index in state.storeGroup){

                if (state.storeGroup[index].id === action.data[0].id){

                    modifiedManagers.push(action.data[0]);
                }
                else{
                    modifiedManagers.push(state.storeGroup[index]);

                }
            }

            return {...state,storeGroup:modifiedManagers,errorUpdate:false};

        case ADMIN_SGROUP_INSERT:

            var modifiedManagers = [];
            for (var index in state.storeGroup){
                modifiedManagers.push(state.storeGroup[index] );
            }

            for (var index in action.data) {
                modifiedManagers.push(action.data[index]);
            }

            return {...state,storeGroup:modifiedManagers,errorUpdate:false};

        case ADMIN_SGROUP_DELETE:

            var modifiedCustomers = [];
            for (var index in state.storeGroup){

                if (state.storeGroup[index].id !== action.id){

                    modifiedCustomers.push({...state.storeGroup[index] });
                }
            }

            return {...state,storeGroup:modifiedCustomers,errorUpdate:false};

        case ROUTES_OPEN_FORM:
            const newRouteState =
                (state.route && (action.id === state.route.id))
                    ? null : action.id;
            return {
                ...state,
                route: newRouteState
            };

        default:
            return state;
    }
}
